import axios from '@/plugins/axiosPlugins'
import runEvn from '@/modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;
/**
 * 获取轮询图
 * @returns
 */
export const getCarouseImg = (carouselmgType, pageNum = 1, pageSize = 1000): Promise<any> => {
    return axios.get(`${baseURL}/CarouseImg?pageNum=${pageNum}&pageSize=${pageSize}&carouselmgType=${carouselmgType}`)
}